import React, { Component } from "react";
import {
    Grid,
    Row,
    Col,
    Dropdown,
    MenuItem,
    Glyphicon,
    FormGroup,
    FormControl,
    InputGroup,
    HelpBlock,
    Modal,
} from "react-bootstrap";

import moment from 'moment'

import Constants from "../../../Phi/Constants";

import { DataphiGrid } from "../../../Components/GridComponent/DataphiGrid/DataphiGrid";
import FormComponent from "../../../Components/FormComponent";
import Validator from "../../../Components/FormComponent/Validator";

import Pagination from "./../../../Components/Pagination";

import HSGModalComponent from "../../HSGModalComponent/HSGModalComponent";

import "./CovidDeclarationList.css";
import DeclarationCard from "../../../Components/DeclarationCard/DeclarationCard";

function covidResultStatus (Id, row) {

    let covidStatusMap = {
        1: {
            groupClass: "hsg-covid-list-risk-status-normal-group",
            textClass: "hsg-covid-list-risk-status-normal-text",
            label: 'Normal'
        },
        2: {
            groupClass: "hsg-covid-list-risk-status-suspected-group",
            textClass: "hsg-covid-list-risk-status-suspected-text",
            label: 'Risk'
        },
        3: {
            groupClass: "hsg-covid-list-risk-status-risk-group",
            textClass: "hsg-covid-list-risk-status-risk-text",
            label: 'High Risk'
        }
    }

    let current = covidStatusMap[row.resultStatus]

    return (

        <div className="center customCenter">
            <div className={current.groupClass}>
                <div className={current.textClass}>{current.label}</div>
            </div>
        </div>
    )
}

function covidDeclarationTime (id, row) {
    var dateFormat = 'MMM Do, h:mm A';
    var testDateUtc = moment.utc(row.declarationDate);
    var localDate = testDateUtc.local();

    return (
        <div className="">{localDate.format(dateFormat)}</div>
    )
}

function covidDeclarationTemperature (id, row) {
    return (
        <div className="">{row.temperature} F</div>
    )
}

const COVID_LIST_HEADER = [
    {
        value: 'Date & Time',
        dataField: 'declarationDate',
        phiDataFormat: (id, row) => covidDeclarationTime(id, row),
        width: '150'
    },
    // {
    //     value: 'Body Temperature',
    //     dataField: 'temperature',
    //     phiDataFormat: (id, row) => (<div className="">{row.temperature} F</div>),
    //     width: '180'
    // },
    {
        value: 'Fever',
        dataField: 'fever',
        phiDataFormat: (id, row) => (<div className="">{row.fever && row.fever.toLowerCase() === "true" ? "Yes":"No"}</div>),
        width: '180'
    },
    {
        value: 'Dry Cough',
        dataField: 'dryCough',
        phiDataFormat: (id, row) => (<div className="">{row.dryCough && row.dryCough.toLowerCase() === "true" ? "Yes":"No"}</div>),
        width: '100'
    },
    {
        value: 'Difficulty Breathing',
        dataField: 'difficultyBreathing',
        phiDataFormat: (id, row) => (<div className="">{row.difficultyBreathing && row.difficultyBreathing.toLowerCase() === "true" ? "Yes":"No"}</div>),
        width: '180'
    },
    {
        value: 'Sore Throat',
        dataField: 'soreThroat',
        phiDataFormat: (id, row) => (<div className="">{row.soreThroat && row.soreThroat.toLowerCase() === "true" ? "Yes":"No"}</div>),
        width: '100'
    },
    {
        dataField: 'resultStatus',
        value: 'Status',
        phiDataFormat: (id, row) => covidResultStatus(id, row),
        width: '100'
    }
  ]
  

class CovidDeclarationList extends Component {
    constructor(props) {
        super(props);

        this.state = {

            defaultListFilters: {
                inUserId: null,
                inOrganizationId: null,
                inLimit: 10,
                inOffset: 0
            },
            activeListFilters: {

            }
        };
    }

    componentDidMount() {
        let { selectedUserId, selectedOrganizationId } = this.props

        if ( selectedUserId ) {
            this.setState({defaultListFilters: {...this.state.defaultListFilters, inUserId: selectedUserId, inOrganizationId: selectedOrganizationId }})
            // this.props.getCovidDeclarationList({...this.state.defaultListFilters, inUserId: selectedUserId, inOrganizationId: selectedOrganizationId })
            this.props.getCovidDeclarationList({...this.state.defaultListFilters, inUserId: selectedUserId })
        }
    }

    componentWillReceiveProps(newProps) {

        let { selectedUserId } = this.props

        if ( newProps.selectedUserId && newProps.selectedUserId !== selectedUserId ) {
            this.setState({defaultListFilters: {...this.state.defaultListFilters, inUserId: newProps.selectedUserId, inOrganizationId: newProps.selectedOrganizationId }})
            // this.props.getCovidDeclarationList({...this.state.defaultListFilters, inUserId: newProps.selectedUserId, inOrganizationId: newProps.selectedOrganizationId })
            this.props.getCovidDeclarationList({...this.state.defaultListFilters, inUserId: newProps.selectedUserId })
        }
    }

    applyCovidListFilter = (filterOptions) => {
        let { defaultListFilters } = this.state;
        let filter = { ...defaultListFilters, ...filterOptions };

        this.props.getCovidDeclarationList(filter);
        this.setState({ defaultListFilters: filter });
    };

    covidListPaginationHandler = (where) => {
        let { defaultListFilters } = this.state;

        let { responseCovidDeclarationList } = this.props;

        let { count } = responseCovidDeclarationList;
        let { inLimit, inOffset } = defaultListFilters

        if (where === "prev") {
            let newOffset = inOffset - inLimit < 0 ? 0 : inOffset - inLimit;
            this.applyCovidListFilter({ inOffset: newOffset });
        } else {
            if (inOffset >= count || inOffset + inLimit >= count) {
                return;
            }
            let newOffset = inOffset + inLimit;
            this.applyCovidListFilter({ inOffset: newOffset });
        }
    };

    covidListPaginationPanel = ({ declarations, count }) => {
        let { defaultListFilters } = this.state;
        let { inLimit, inOffset } = defaultListFilters || {};

        return (
            <Pagination
                inOffset={inOffset}
                showNext={this.covidListPaginationHandler}
                data={declarations || []}
                total={count || 0}
                className={"left padding-left-3rem"}
            />
        );
    };

    render() {

        let { responseCovidDeclarationList } = this.props
         
        return (
            <div className="hsg-covid-declaration-list-root">
                <div className="container-fluid">
                    <div className="hsg-covid-declaration-list-group hsg-covid-declaration-list-card">
                       <div className = "hidden-xs">
                            <DataphiGrid 
                                bordered={false}
                                // selectRow={this.props.selectRowProp}
                                options={{
                                    paginationPanel: (props) => this.covidListPaginationPanel(responseCovidDeclarationList),
                                    // onPageChange: (page, sizePerPage) => this.onPageChange(page, sizePerPage),
                                    // onSortChange: (sn, so) => this.onSortChange(sn, so),
                                    // onAddRow: row => this.onAddRow(row),
                                    // toolBar: props => this.toolbar(props),
                                }}
                                data={responseCovidDeclarationList.declarations || []}
                                pagination
                                keyField={"declarationDate"}
                                tableHeaderColumn={COVID_LIST_HEADER}
                                remote={true}
                                tableContainerClass="hsg-community-list-user-list-grid"
                                tableHeaderClass="hsg-covid-list-user-list-grid-header"
                                tableBodyClass="hsg-community-list-user-list-grid-body"
                                containerClass="my-container-class"
                                headerContainerClass="my-header-container-class"
                                bodyContainerClass="my-body-container-class"
                            />
                       </div>
                        <div className = "hidden-sm hidden-md hidden-lg">
                            <DeclarationCard 
                                data={responseCovidDeclarationList.declarations || []} 
                                covidResultStatusHandler = {covidResultStatus}
                                covidDeclarationTimeHandler = {covidDeclarationTime}
                                COVID_LIST_HEADER = {COVID_LIST_HEADER}
                                covidListPaginationPanelHandler = {() => this.covidListPaginationPanel(responseCovidDeclarationList)}
                            />
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default CovidDeclarationList;
